export default __webpack_public_path__ + "bcbb524325a9b7dc70f8ae11e1a33908.png";